// src/utils/scriptLoader.ts
// Utilidad para cargar scripts externos en orden

/**
 * Carga un script externo y devuelve una promesa que se resuelve cuando el script está cargado
 * @param src URL del script a cargar
 * @returns Promesa que se resuelve cuando el script está cargado
 */
export const loadScript = (src: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    // Verifica si el script ya está cargado
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;

    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Error cargando script: ${src}`));

    document.body.appendChild(script);
  });
};

/**
 * Carga múltiples scripts en orden secuencial
 * @param scripts Array de URLs de scripts a cargar
 * @returns Promesa que se resuelve cuando todos los scripts están cargados
 */
export const loadScriptsSequentially = async (scripts: string[]): Promise<void> => {
  for (const script of scripts) {
    try {
      await loadScript(script);
    } catch (error) {
      console.error(error);
    }
  }
};

/**
 * Limpia los scripts cargados del DOM
 * @param scripts Array de URLs de scripts a limpiar
 */
export const cleanupScripts = (scripts: string[]): void => {
  scripts.forEach(src => {
    const scriptTag = document.querySelector(`script[src="${src}"]`);
    if (scriptTag) document.body.removeChild(scriptTag);
  });
};

/**
 * Lista de scripts de Kidsa que se necesitan para la plantilla
 */
export const kidsaScripts = [
  '/assets/js/jquery-3.7.1.min.js',
  '/assets/js/viewport.jquery.js',
  '/assets/js/bootstrap.bundle.min.js',
  '/assets/js/jquery.nice-select.min.js',
  '/assets/js/jquery.waypoints.js',
  '/assets/js/jquery.counterup.min.js',
  '/assets/js/swiper-bundle.min.js',
  '/assets/js/jquery.meanmenu.min.js',
  '/assets/js/jquery.magnific-popup.min.js',
  '/assets/js/wow.min.js',
  '/assets/js/main.js'
];
